import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function SkillComponent(props: any) {
    return (
        <Container
            className='glass p-3 mb-3'
            style={{
                width: 'fit-content',
                minWidth: '250px',
                maxWidth: `${props.Parrent ? '740px' : '330px'}`, // If container is parrent then set max width to 740px else 330px
            }}
        >
            <Row className='justify-content-center mb-4'>
                <Col
                    xs='auto'
                    sm='auto'
                    md='auto'
                    lg='auto'
                    xl='auto'
                    xxl='auto'
                >
                    <div style={{
                        fontSize: '1.5rem',
                    }} className='text'>{props.Title}</div>
                </Col>
            </Row>
            <Row xs="auto" className="justify-content-center">
            {React.Children.toArray(props.children).map((child: any, index: any) => {
                return (
                    <Col className='justify-content-center mb-3' key={index}>{child}</Col>
                );
            })}
            </Row>
        </Container>
    );
}
